import useShopifyFetcher from '../shopify'
import { Fetcher } from '@Types/fetcher'

function useGetRedirectUrl(): Fetcher {
  const [baseFetcher, meta] = useShopifyFetcher()

  const getRedirectUrl = async (redirect: string, panelId: number) => {
    return await baseFetcher(
      `${import.meta.env.VITE_APP_URL}/shopify/redirect`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ redirect, panel_id: panelId }),
      },
    )
  }

  return [getRedirectUrl, meta]
}

export default useGetRedirectUrl
